module.exports = __webpack_public_path__ + "assets/img/WechatPayWhite.9f06caec.svg";